module.exports = __webpack_public_path__ + "static/media/mi2.d8a48381.jpg";